<hlm-badge
  [ngClass]="{ 'finx-tag-active': isActive, 'finx-tag-inactive': !isActive, 'finx-tag-icon': !hideCloseIcon }"
  class="finx-tag"
>
  <div class="d-flex align-items-center" (click)="tagClicked()">
    <p class="align-items-center" [ngClass]="textStyleClass">{{ label }}</p>
    <div *ngIf="!hideCloseIcon && isActive" class="h-100">
      <mat-icon
        [ngStyle]="iconContentStyle"
        *ngIf="filterPillConfig && icon !== ''"
        [svgIcon]="icon"
        class="icon-flex"
      />
    </div>
  </div>
</hlm-badge>
